import { Option } from '../Requests/SortBy.styles';

export const LinkOption = Option.withComponent('a');
